import React from "react";
import { FileText, Clock } from "lucide-react";

// 2026-02-23 (Dave) — Admin → Reports selection screen. Illustration-only
// wiring to the static mockup in `frontend/public/`. Same
// `REPORT_CACHE_KEY` bust value used by the Association-tab Reserve
// Budget Report button so iOS Safari doesn't serve stale HTML.
// 2026-03 (Dave) — Board & Advisors edition retired. The Reserve
// Budget Report is now a single 4-page owner-facing document.

const REPORTS = [
  {
    key: "reserve_budget",
    title: "Reserve Budget Report",
    description:
      "Four-page plain-language digest for members — funding-level snapshot, expected contributions, waterfall projection, and a plain-English summary of the plan's health.",
    icon: FileText,
    testid: "reports-card-reserve-budget",
  },
];

export default function ReportsScreen() {
  return (
    <div className="panel-compact flex flex-col" data-testid="screen-reports">
      <div className="section-title-sm flex items-baseline justify-between">
        <span>Reports</span>
        <span
          className="text-slate font-sans font-normal text-[11px] tracking-[0.06em]"
          data-testid="reports-illustration-note"
        >
          <span className="uppercase text-[10px] tracking-[0.12em] font-semibold text-coral mr-1.5">
            Coming Soon:
          </span>
          Reserve Budget Report is in development.
        </span>
      </div>

      <div
        className="mt-4 grid gap-3"
        style={{ gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))" }}
        data-testid="reports-item-grid"
      >
        {REPORTS.map((it) => {
          const Icon = it.icon;
          return (
            <div
              key={it.key}
              data-testid={it.testid}
              className="text-left border border-rule bg-white p-4 rounded-[3px] cursor-default select-none"
              aria-disabled="true"
            >
              <div className="flex items-center gap-2">
                <Icon size={16} className="text-slate" strokeWidth={1.8} />
                <span className="font-display text-[15px] text-slate font-bold">
                  {it.title}
                </span>
              </div>
              <div className="mt-2 text-[12px] text-slate leading-snug">
                {it.description}
              </div>
              <div className="mt-3 inline-flex items-center gap-1 text-[11px] font-semibold text-coral tracking-[0.04em]">
                <Clock size={11} strokeWidth={2} />
                Coming Soon…
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
